module.exports = __webpack_public_path__ + "img/bread-account-center-research.943f49f9.png";